module.exports = __webpack_public_path__ + "img/duocolour.65664a04.jpg";